import { useEffect } from 'react';

const STORAGE_KEY = 'solace_ref';
const MAX_LENGTH = 100;

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'] as const;
type UtmKey = typeof UTM_KEYS[number];
const UTM_STORAGE_PREFIX = 'solace_';

export function getReferralSource(): string {
  try {
    return localStorage.getItem(STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function getUtmParams(): Record<UtmKey, string> {
  const result = { utm_source: '', utm_medium: '', utm_campaign: '' };
  try {
    for (const key of UTM_KEYS) {
      result[key] = localStorage.getItem(`${UTM_STORAGE_PREFIX}${key}`) || '';
    }
  } catch {
    // ignore
  }
  return result;
}

export function useReferralTracking() {
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const ref = params.get('ref');
      if (ref) {
        const cleaned = ref.trim().slice(0, MAX_LENGTH);
        if (cleaned) {
          localStorage.setItem(STORAGE_KEY, cleaned);
        }
      }
      for (const key of UTM_KEYS) {
        const value = params.get(key);
        if (value) {
          const cleaned = value.trim().slice(0, MAX_LENGTH);
          if (cleaned) {
            localStorage.setItem(`${UTM_STORAGE_PREFIX}${key}`, cleaned);
          }
        }
      }
    } catch {
      // ignore
    }
  }, []);
}
